export enum MimeTypeEnum {
  ApplicationEpubZip = "application/epub+zip",
  ApplicationGzip = "application/gzip",
  ApplicationJavaArchive = "application/java-archive",
  ApplicationJson = "application/json",
  ApplicationLdJson = "application/ld+json",
  ApplicationMsword = "application/msword",
  ApplicationOctetStream = "application/octet-stream",
  ApplicationOgg = "application/ogg",
  ApplicationPdf = "application/pdf",
  ApplicationRtf = "application/rtf",
  ApplicationVndAmazonEbook = "application/vnd.amazon.ebook",
  ApplicationVndAppleInstallerXml = "application/vnd.apple.installer+xml",
  ApplicationVndMozillaXulXml = "application/vnd.mozilla.xul+xml",
  ApplicationVndMsExcel = "application/vnd.ms-excel",
  ApplicationVndMsFontobject = "application/vnd.ms-fontobject",
  ApplicationVndMsPowerpoint = "application/vnd.ms-powerpoint",
  ApplicationVndOasisOpendocumentPresentation = "application/vnd.oasis.opendocument.presentation",
  ApplicationVndOasisOpendocumentSpreadsheet = "application/vnd.oasis.opendocument.spreadsheet",
  ApplicationVndOasisOpendocumentText = "application/vnd.oasis.opendocument.text",
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ApplicationVndRar = "application/vnd.rar",
  ApplicationVndVisio = "application/vnd.visio",
  ApplicationX7zCompressed = "application/x-7z-compressed",
  ApplicationXAbiword = "application/x-abiword",
  ApplicationXBzip = "application/x-bzip",
  ApplicationXBzip2 = "application/x-bzip2",
  ApplicationXCdf = "application/x-cdf",
  ApplicationXCsh = "application/x-csh",
  ApplicationXhtmlXml = "application/xhtml+xml",
  ApplicationXHttpdPhp = "application/x-httpd-php",
  ApplicationXml = "application/xml",
  ApplicationXSh = "application/x-sh",
  ApplicationXShockwaveFlash = "application/x-shockwave-flash",
  ApplicationXTar = "application/x-tar",
  ApplicationZip = "application/zip",
  Audio3gpp = "audio/3gpp",
  Audio3gpp2 = "audio/3gpp2",
  AudioAAC = "audio/aac",
  AudioMidi = "audio/midi",
  AudioMpeg = "audio/mpeg",
  AudioOgg = "audio/ogg",
  AudioOpus = "audio/opus",
  AudioWav = "audio/wav",
  AudioWebm = "audio/webm",
  AudioXMidi = "audio/x-midi",
  FontOtf = "font/otf",
  FontTtf = "font/ttf",
  FontWoff = "font/woff",
  FontWoff2 = "font/woff2",
  ImageAvif = "image/avif",
  ImageBmp = "image/bmp",
  ImageGif = "image/gif",
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
  ImageSvgXml = "image/svg+xml",
  ImageTiff = "image/tiff",
  ImageVndMicrosoftIcon = "image/vnd.microsoft.icon",
  ImageWebp = "image/webp",
  TextCalendar = "text/calendar",
  TextCss = "text/css",
  TextCsv = "text/csv",
  TextHtml = "text/html",
  TextJavascript = "text/javascript",
  TextPlain = "text/plain",
  Video3gpp = "video/3gpp",
  Video3gpp2 = "video/3gpp2",
  VideoMp2t = "video/mp2t",
  VideoMp4 = "video/mp4",
  VideoMpeg = "video/mpeg",
  VideoOgg = "video/ogg",
  VideoWebm = "video/webm",
  VideoXMsvideo = "video/x-msvideo",
}
